export default "__VITE_ASSET__a98e25c1__"